import { useEffect, useState } from "react";
import { useGetPlatformInfo } from "../../queries/auth";
import { ButtonSize, PrimaryCTAButton } from "../../shared/CTAButtonComponents";
import { HStack, VStack } from "../../shared/utils";
import { useAuthStore } from "../../store/useAuthStore";
import { AdminMainPage } from "./AdminMainPage";
import { ActionCards } from "./Components/gettingStartedCards";
import { ProductCards } from "./Components/productCards";
import SampleCard from "./Components/sampleCard";
import { Tickers, TickerType } from "./Components/Tickers";
import { SharedPagesCard } from "./Components/SharedPagesCard";
import Loader from "../../utils/loader";
import { TickerPlaceholder } from "../../utils/placeholders";

// import { useAuthStore } from "../../store/useAuthStore";
// import extractMyTasks from "../myTask/useExtractMyTask";

export default function HomePage() {
  const { accessToken } = useAuthStore();
  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [platformData, setPlatformData] = useState<any>(null);

  const [tickerData, setTickerData] = useState<TickerType[]>();
  const s3Url =
    "https://equion-dev.s3.us-west-2.amazonaws.com/demoPages/Tickers/tickerData.json";

  const fetchData = async () => {
    try {
      const response = await fetch(s3Url);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
      setTickerData(jsonData?.TickerData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [s3Url]);

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData);
    }
  }, [userPlatformData]);

  // const { id: userId } = useAuthStore();

  // const myTasks = extractMyTasks(userData, userId ?? "");

  return (
    <>
      {/* Getting Started Card */}
      {/* <div className="px-4 sm:px-6 flex-1 lg:p-6 bg-white pt-6 border border-borderColor shadow-box rounded-md">
        <p className="text-lg">Getting Started</p>
        <p className="text-sm text-gray-400">
          Feel free to explore or get a head start below
        </p>

        <HStack className="flex flex-wrap justify-center md:justify-between gap-4 mb-4 md:mb-0 mt-4 ">
          <ActionCards
            image={"/media/importCaptable.svg"}
            title={"Import your Captable"}
            onClick={() => {}}
          />
          <ActionCards
            image={"/media/tour.svg"}
            title={"Take a Mini Tour"}
            onClick={() => {}}
          />
          <ActionCards
            image={"/media/invRounds.svg"}
            title={"Model Investment Rounds"}
            onClick={() => {}}
          />
          <ActionCards
            image={"/media/profileSetup.svg"}
            title={"Set up your Profile"}
            onClick={() => {}}
          />
        </HStack>
      </div> */}

      {/* Tickers */}
      <div className="mt-6">
        {tickerData ? <Tickers tickerData={tickerData} /> : <TickerPlaceholder/>}
      </div>

      {/* Product Cards */}
      <ProductCards data={platformData || []} />

      {/* Shared with Me Card */}
      <div className="md:grid md:grid-cols-3 md:gap-6 mt-6">
        <div className="col-span-3">
          <SharedPagesCard />
        </div>
        {/* Book a demo card */}
        {/* <div className="mt-6 md:mt-0">
          <div className="px-4 sm:px-6 flex-1 lg:p-8 bg-white pt-6 border border-borderColor shadow-box rounded-xl h-[600px]">
            <div className="h-[500px] py-4">
              <VStack>
                <img
                  className="h-45 mx-auto w-45"
                  src={"/media/icons/infoIcon.svg"}
                  alt="hissa_logo"
                />
                <p className="text-lg text-center pt-4">
                  Equity Management Solutions for Founders, Employees, &
                  Investors
                </p>

                <div className="mt-6 text-center">
                  <PrimaryCTAButton
                    event-name="Email Continue"
                    className="w-32 text-center px-auto "
                    buttonSize={ButtonSize.MEDIUM}
                    // loading={props.loading}
                    type="button"
                  >
                    <p className="w-full text-sm leading-0"> Book a Demo</p>
                  </PrimaryCTAButton>
                </div>
              </VStack>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}
